(function initializeProductCardMobileSwipe() {
  const mobileBreakpoint = 1024;
  const swipeThreshold = 35;
  let activeMedia = null;
  let startX = 0;
  let startY = 0;

  function setActiveSlide(media, showSecondary) {
    media.classList.toggle('is-secondary-active', showSecondary);

    const dots = media.querySelectorAll('.card-media-pagination > span');
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === (showSecondary ? 1 : 0));
    });
  }

  document.addEventListener('touchstart', (event) => {
    if (window.innerWidth > mobileBreakpoint || event.touches.length !== 1) return;

    const media = event.target.closest('[data-card-media-swipe]');
    if (!media) return;

    activeMedia = media;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (!activeMedia || event.changedTouches.length !== 1) return;

    const deltaX = event.changedTouches[0].clientX - startX;
    const deltaY = event.changedTouches[0].clientY - startY;
    const media = activeMedia;
    activeMedia = null;

    if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) return;

    event.preventDefault();
    setActiveSlide(media, deltaX < 0);
    media.dataset.preventCardClick = 'true';
    window.setTimeout(() => {
      delete media.dataset.preventCardClick;
    }, 500);
  }, { passive: false });

  document.addEventListener('click', (event) => {
    const cardLink = event.target.closest('[data-card-media-swipe] .card-link');
    const media = cardLink?.closest('[data-card-media-swipe]');

    if (media?.dataset.preventCardClick === 'true') {
      event.preventDefault();
      event.stopPropagation();
      delete media.dataset.preventCardClick;
    }

    const swatch = event.target.closest('.product-item .card-swatch .swatch-label');
    if (swatch) {
      const productItem = swatch.closest('.product-item');
      const swipeMedia = productItem?.querySelector('[data-card-media-swipe]');
      if (swipeMedia) setActiveSlide(swipeMedia, false);
    }
  }, true);
})();
